import styled from "styled-components"
import { Container, Grid } from "@mui/material"
import CustomButton from "../../components/custom-button/custom-button.component"

export const Background = styled(Container)`
  background-color: #ffffff;
  padding-bottom: 6em;
`

export const ButtonWrapperRight = styled.div`
  text-align: right;
`

export const ButtonWrapperCenter = styled.div`
  margin-top: -8.5em;
  margin-bottom: 4em;
  text-align: center;

  button {
    pointer-events: none;
    text-transform: unset;
    width: 50%;
    font-size: ${({ theme }) => theme.typography.pxToRem(32)};
    line-height: ${({ theme }) => theme.typography.pxToRem(38)};
  }
`

export const Tabs = styled(Grid)`
  padding-top: 6em;
`

export const TabsContainer = styled.div`
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  a {
    align-self: center;
    font-family: "Roboto", sans-serif;
    text-align: center;
    outline: none;
    margin-bottom: 0.25em;
    padding: 1em 0;
    background-color: transparent;
    border-bottom: 1px solid #979797;
    color: #000000;
    opacity: 0.5;
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    flex: 1 1 140px;

    &.active {
      border-bottom: 4px solid #d21e1e;
      opacity: 1;
    }
  }
`

export const BackgroundMenu = styled.div`
  background-color: #fafafa;
  padding-top: 6em;
`

export const Text = styled.div`
  padding-bottom: 2em;

  p {
    font-size: 20px;
  }

  h4,
  h3 {
    font-size: 28px;
  }

  > h2 {
    margin-top: 2em;
    text-align: center;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  ul {
    margin-top: 0.5em;
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  }
`

export const Button = styled(CustomButton)`
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
`

export const Columns = styled(Grid)`
  padding-top: 4em;
  padding-bottom: 4em;
`
